import { TERMINAL_MODE } from '@env'
import { Dimensions } from 'react-native'

const ORGANIZATION_IDS = {
	CA_BC_VANCOUVER_FOOD_REPUBLIC: 'CA-BC-Vancouver-FoodRepublic',
	GKB_MISSISSAUGA: 'gkb-mississauga',
	GKB_BURLINGTON: 'gkb-burlington',
	CLUB_KITCHEN: 'clubkitchen',
	MOD_KITCHEN: 'modkitchen',
	KITCHENONE: 'kitchenone',
	CITY_FOUNDRY_STL: 'cityfoundry-stl',
	FLYTES_BNA: 'flytes-bna',
}

// For kiosk app, TERMINAL_MODE is set to false. For all other apps, TERMINAL_MODE is set to true.
// If building for kiosk, set const isKiosk = true. Run ./gradlew assembleKioskRelease within the android directory.
// const isKiosk = true
const isKiosk = TERMINAL_MODE === 'true'

global.multi = true

if (isKiosk) {
	global.kiosk = true
	global.tipLarge = false
	global.idleReset = true
	global.kioskV2 = Dimensions.get('window').width <= 900
} else {
	// Can handle subdomains here.
	// const subdomain = window.location.hostname.split('.')[0]

	// global.org = ORGANIZATION_IDS.CA_BC_VANCOUVER_FOOD_REPUBLIC
	// global.org = ORGANIZATION_IDS.GKB_BURLINGTON
	// global.org = ORGANIZATION_IDS.GKB_MISSISSAUGA;
	global.org = ORGANIZATION_IDS.CLUB_KITCHEN
	// global.org = ORGANIZATION_IDS.MOD_KITCHEN
	// global.org = ORGANIZATION_IDS.KITCHENONE
	// global.org = ORGANIZATION_IDS.CITY_FOUNDRY_STL
	// global.org = ORGANIZATION_IDS.FLYTES_BNA
}
